import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pause, Play, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

const waHref = (text, link) => {
  const url = link ? (link.startsWith("/") ? `${window.location.origin}${link}` : link) : window.location.origin;
  return `https://wa.me/?text=${encodeURIComponent(`🔴 FLASH INFO — ${text}\n${url}`)}`;
};

export const Ticker = () => {
  const [items, setItems] = useState([]);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const load = () => api.get("/ticker").then((r) => setItems(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!items.length) return null;
  const loop = [...items, ...items];

  return (
    <div data-testid="flash-infos-ticker" className="bg-[#E9EBEF] border-b border-zinc-300">
      <div className="container-site flex items-stretch h-11">
        <div className="flex items-center gap-2 bg-white px-4 shrink-0 relative">
          <span className="w-2.5 h-2.5 rounded-full bg-red-600 live-dot" />
          <span className="font-heading font-extrabold text-xs uppercase tracking-wider">Flash infos</span>
          <span className="absolute right-[-11px] top-0 h-full w-0 border-y-[22px] border-y-transparent border-l-[11px] border-l-white" />
        </div>
        <div className="ticker-wrap flex-1 overflow-hidden ml-5 flex items-center">
          <div className={`ticker-track ${paused ? "paused" : ""}`}>
            {loop.map((it, i) => {
              const internal = it.link?.startsWith("/");
              const Comp = internal ? Link : "a";
              const props = internal ? { to: it.link } : { href: it.link || "#" };
              const first = i < items.length;
              return (
                <span key={`${it.id}-${i}`} className="flex items-center border-r border-zinc-300 pr-2">
                  <Comp {...props} data-testid={first ? `ticker-item-${i}` : undefined} className="pl-6 pr-2 text-[13px] font-semibold text-[#0F172A] hover:text-red-600 whitespace-nowrap transition-colors">{it.text}</Comp>
                  <a href={waHref(it.text, it.link)} target="_blank" rel="noreferrer" aria-label="Partager sur WhatsApp" data-testid={first ? `ticker-whatsapp-${i}` : undefined} className="w-6 h-6 rounded-full flex items-center justify-center text-[#25D366] hover:bg-[#25D366] hover:text-white transition-colors" title="Partager sur WhatsApp">
                    <MessageCircle size={14} />
                  </a>
                </span>
              );
            })}
          </div>
        </div>
        <button data-testid="ticker-pause-btn" onClick={() => setPaused((p) => !p)} aria-label={paused ? "Lecture" : "Pause"} className="w-10 shrink-0 flex items-center justify-center text-zinc-500 hover:text-red-600 transition-colors">
          {paused ? <Play size={14} /> : <Pause size={14} />}
        </button>
      </div>
    </div>
  );
};
